import {gsap} from "gsap";
import {isMobile, isTablet} from "../components/helpers";
import {initImacScene} from "../components/imac";

export function initVoznesenskyLanding() {
    if (!$('#voznesensky_landing').length) return;

    initFirstScreenGsap()

    initImacScene()

    function initFirstScreenGsap() {
        const bgCircleTop = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensky-bg'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=100% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.circle-bg.top'), {
            translateX: '0%',
            willChange: 'transform',
        }).to($('.circle-bg.top'), {
            translateX: '100%',
            willChange: 'transform',
        })

        const bgCircleBottom = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensky-bg'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=100% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.circle-bg.bottom'), {
            translateX: '100%',
            willChange: 'transform',
        }).to($('.circle-bg.bottom'), {
            translateX: '0%',
            willChange: 'transform',
        })

        const voznesenskyLogo = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensky-logo').parents('.container'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: isMobile() || isTablet() ? 'top-=200% bottom' : 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.voznesensky-logo'), {
            translateX: '30%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.voznesensky-logo'), {
            translateX: '-30%',
            willChange: 'transform',
        })

        const vosnesenskyFirstThing = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensy-things-col .item.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.voznesensy-things-col .item.first'), {
            rotateZ: '-12',
            transformOrigin: 'center center',
            willChange: 'transform',
            duration: 0.2,
        }).to($('.voznesensy-things-col .item.first'), {
            rotateZ: '12',
            transformOrigin: 'center center',
            willChange: 'transform',
        })

        const vosnesenskySecondThing = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensy-things-col .item.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.voznesensy-things-col .item.second'), {
            rotateZ: '105',
            transformOrigin: 'center center',
            willChange: 'transform',
            duration: 0.2,
        }).to($('.voznesensy-things-col .item.second'), {
            rotateZ: '75',
            transformOrigin: 'center center',
            willChange: 'transform',
        })

        const vosnesenskyThirdThing = gsap.timeline({
            scrollTrigger: {
                trigger: $('.voznesensy-things-col .item.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.voznesensy-things-col .item.third'), {
            rotateZ: '6',
            transformOrigin: 'center center',
            willChange: 'transform',
            duration: 0.2,
        }).to($('.voznesensy-things-col .item.third'), {
            rotateZ: '-20',
            transformOrigin: 'center center',
            willChange: 'transform',
        })
    }
}
